/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as UserActions from '@/app/auth/store/actions/user.actions';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomPhoneInput from '@/app/customComponents/CustomPhoneInput/CustomPhoneInput';
import { updateProfile } from '@/app/services/Superadminprodile/Superadminprodile';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import jwtService from '@/app/services/jwtService';
import * as Actions from '@/app/store/actions';
import { getImageUrl, isImageFile, isInValidName } from '@/utils/utils';
import { Avatar, CircularProgress, IconButton, TextField } from '@material-ui/core';
import { isPossiblePhoneNumber } from 'libphonenumber-js/min';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './adminDetail.css';
import { useNavigate } from 'react-router-dom';

const Editprofile = () => {
	const navigate = useNavigate();
	const inputRef = useRef(null);
	const [selectedFile, setSelectedFile] = useState();
	const [errTxts, setErrTxts] = useState({});
	const [isSaving, setIsSaving] = useState(false);
	const dispatch = useDispatch();
	const { role: userRole, school } = useSelector(({ auth }) => auth.user);
	const isSuperSchoolAdmin = userRole[0] === 'super_school_admin';
	// modified data js

	const [modifieduser, setModifieduser] = useState({
		// photo:'',
		// first_name:'',
		// last_name:'',
		// phone:'',
		// email:''
	});
	const [preview, setPreview] = useState(modifieduser?.photo);
	const [isLoading, setIsLoading] = useState(true);
	const handleChange = (e) => {
		const { name, value } = e.target;
		setErrTxts({ ...errTxts, [name]: '' });
		setModifieduser({ ...modifieduser, [name]: value });
	};

	useEffect(() => {
		let isMounted = true;
		jwtService
			.getProfile(isSuperSchoolAdmin)
			.then((res) => {
				if (!isMounted) return;
				setIsLoading(false);
				setModifieduser(res.data);
			})
			.catch((error) => {
				if (!isMounted) return;
				setIsLoading(false);
				console.error('data is invalid', error);
			});

		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		if (!selectedFile) {
			setPreview(modifieduser?.photo);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile, modifieduser?.photo]);

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(null);
			return;
		}
		// check if the file is img or not
		const file = e.target.files[0];
		if (!isImageFile(file)) {
			dispatch(Actions.showMessage({ message: 'Please select an image file', variant: 'error' }));
		} else {
			setSelectedFile(e.target.files[0]);
		}
	};
	// end image js

	// update data
	const handleSubmit = () => {
		if (!modifieduser.first_name) {
			setErrTxts({ ...errTxts, first_name: 'This field is required' });
			return;
		}
		if (modifieduser.first_name && isInValidName(modifieduser.first_name)) {
			setErrTxts({ ...errTxts, first_name: 'Please enter a valid name.' });
			return;
		}
		modifieduser.first_name = modifieduser.first_name.trim();
		if (!modifieduser.last_name) {
			setErrTxts({ ...errTxts, last_name: 'This field is required' });
			return;
		}
		if (modifieduser.last_name && isInValidName(modifieduser.last_name)) {
			setErrTxts({ ...errTxts, last_name: 'Please enter a valid name.' });
			return;
		}
		modifieduser.last_name = modifieduser.last_name.trim();

		if (modifieduser.phone) {
			if (isPossiblePhoneNumber(modifieduser.phone, 'US') === false) {
				setErrTxts({ ...errTxts, phone: 'Please enter valid phone number' });
				return;
			}
		}

		if (!modifieduser.email) {
			setErrTxts({ ...errTxts, email: 'This field is required' });
			return;
		}
		if (!/^\S+@\S+\.\S+$/.test(modifieduser.email)) {
			setErrTxts({ ...errTxts, email: 'Please enter valid email' });
			return;
		}

		if (!modifieduser.phone) {
			setErrTxts({ ...errTxts, phone: 'This field is required' });
			return;
		}

		if (selectedFile) {
			const filename = getImageUrl(selectedFile);
			setIsSaving(true);
			uploadFile(selectedFile, filename)
				.then((response) => {
					modifieduser.image = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					updateProfile(modifieduser, isSuperSchoolAdmin)
						.then(() => {
							jwtService.getProfile(isSuperSchoolAdmin).then((res) => {
								const user = {
									data: {
										email: res.data.email,
										displayName: `${res.data.first_name} ${res.data.last_name}`,
										photoURL: res.data.photo,
										...res.data,
									},
									school: isSuperSchoolAdmin ? school : {},
									doNotRedirect: 1,
									role: [isSuperSchoolAdmin ? 'super_school_admin' : res.data.role],
								};
								dispatch(UserActions.setUserData(user));
							});
							dispatch(
								Actions.showMessage({
									message: 'Profile updated Successfully',
									autoHideDuration: 1500,
									variant: 'success',
								}),
							);
							navigate(-1);
						})
						.catch((err) => {
							if (err.response?.data?.errors) {
								setErrTxts(err.response.data.errors);
							} else {
								dispatch(
									Actions.showMessage({
										message: 'Failed to edit modifieduser information.',
										autoHideDuration: 1500,
										variant: 'error',
									}),
								);
							}
						})
						.finally(() => setIsSaving(false));
				})
				.catch(() => {
					dispatch(
						Actions.showMessage({
							message: 'Failed to upload image.',
							autoHideDuration: 1500,
							variant: 'error',
						}),
					);
					setIsLoading(false);
				});
		} else {
			setIsSaving(true);
			updateProfile(modifieduser, isSuperSchoolAdmin)
				.then((resp) => {
					jwtService
						.getProfile(isSuperSchoolAdmin)
						.then((res) => {
							console.log({ res });
							const user = {
								data: {
									email: res.data.email,
									displayName: `${res.data.first_name} ${res.data.last_name}`,
									photoURL: res.data.photo,
									...res.data,
								},
								school: isSuperSchoolAdmin ? school : {},
								doNotRedirect: 1,
								role: [isSuperSchoolAdmin ? 'super_school_admin' : res.data.role],
							};
							dispatch(UserActions.setUserData(user));
						})
						.catch((err) => {
							console.log({ ...err });
						});
					dispatch(
						Actions.showMessage({
							message: resp.data.message,
							autoHideDuration: 1500,
							variant: 'success',
						}),
					);
					navigate(-1);
				})
				.finally(() => setIsSaving(false));
		}
	};

	return (
		<div className="profile-cont mx-auto">
			<div className="profileinfo flex items-center flex-nowrap justify-between mx-auto">
				{/* <span className="personal-hdd text-pd-2xl self-end font-extrabold ">
					<h1>Edit Profile</h1>
				    </span> */}
				<span className="totalRooms-heading" style={{ fontSize: '20px', fontWeight: '700' }}>
					<span className="">
						<IconButton
							onClick={() => {
								navigate(-1);
							}}
						>
							<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
						</IconButton>
					</span>
					Edit Profile
				</span>
			</div>

			<div className="bg-white rounded   mx-auto profile-bgg">
				{isLoading ? (
					<div className="flex justify-between" style={{ marginLeft: '' }}>
						<CircularProgress className="m-auto justtify-center items-center" />
					</div>
				) : (
					<>
						<div className="flex justify-center">
							<div className="flex justify-between">
								<div
									className="relative pic-upload-overlay cursor-pointer mx-40"
									onClick={() => inputRef.current.click()}
								>
									<Avatar className="imageupload" src={preview} style={{ height: '140px', width: '140px' }} />
									<div className="pp-input-overlay">
										<i className="fa fa-2x fa-camera" />
									</div>
									<input
										accept="image/*"
										className="hidden"
										id="image"
										name="image"
										onChange={onSelectFile}
										ref={inputRef}
										type="file"
									/>
								</div>

								<div className="grid grid-cols-2 flex-grow pl-20 gap-64 mb-64">
									<TextField
										error={!!errTxts.first_name}
										helperText={errTxts.first_name}
										label="First Name"
										name="first_name"
										onChange={handleChange}
										required
										value={modifieduser.first_name || ''}
									/>
									<TextField
										error={!!errTxts.last_name}
										helperText={errTxts.last_name}
										label="Last Name"
										name="last_name"
										onChange={handleChange}
										required
										value={modifieduser.last_name || ''}
									/>
									<CustomPhoneInput
										error={!!errTxts.phone}
										helperText={errTxts.phone}
										label="Contact Number"
										name="phone"
										onChange={(e) => {
											const { value } = e.target;
											handleChange(e);
											if (isPossiblePhoneNumber(value, 'US') === false) {
												setErrTxts({ ...errTxts, phone: 'valid phone number required' });
											} else {
												setErrTxts({ ...errTxts, phone: '' });
											}
										}}
										required
										value={modifieduser.phone || ''}
									/>
									<TextField
										className="capitalize-text justify-end"
										disabled
										error={errTxts.email}
										helperText={errTxts.email}
										label="Email Address"
										name="email"
										required
										value={modifieduser.email || ''}
									/>
								</div>
							</div>
						</div>

						<div className="btnedit">
							{!isSaving ? (
								<div className=" center-btn">
									<CustomButton
										onClick={() => {
											navigate(-1);
										}}
										variant="secondary"
										width={140}
									>
										Cancel
									</CustomButton>

									<CustomButton onClick={handleSubmit} variant="primary" width={140}>
										Update
									</CustomButton>
								</div>
							) : (
								<div className="flex justify-center">
									<CircularProgress className="mx-auto" />
								</div>
							)}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default Editprofile;
